module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.imgArr), function(item) {
    return _c('swiper-slide', {
      key: item.src
    }, [_c('img', {
      attrs: {
        "src": item.src
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-92afffde"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/swipe.vue
// module id = 25
// module chunks = 0